"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _phoneVerification = require("../../utils/phone-verification.utils");
var _patterns = require("../../utils/patterns");
var _toast = require("../../utils/toast");
var _Button = require("../../components/Button");
var _phoneNumber = require("../../utils/phone-number.utils");
var _components = require("../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var fieldName = 'verificationCode';
var useResendTimer = function useResendTimer() {
  var RESEND_INTERVAL = 30;
  var intervalRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(RESEND_INTERVAL),
    _useState2 = _slicedToArray(_useState, 2),
    secondsLeft = _useState2[0],
    setSecondsLeft = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    resets = _useState4[0],
    setResets = _useState4[1];
  var decrease = function decrease() {
    return setSecondsLeft(function (prev) {
      return prev - 1;
    });
  };
  (0, _react.useEffect)(function () {
    setSecondsLeft(RESEND_INTERVAL);
    intervalRef.current = setInterval(decrease, 1000);
    return function () {
      clearInterval(intervalRef.current);
    };
  }, [resets]);
  return {
    reset: function reset() {
      setResets(function (prev) {
        return prev + 1;
      });
    },
    secondsLeft: secondsLeft
  };
};
var PhoneNumberVerification = function PhoneNumberVerification(_ref) {
  var form = _ref.form,
    loading = _ref.loading,
    phoneNumber = _ref.phoneNumber,
    _ref$skippable = _ref.skippable,
    skippable = _ref$skippable === void 0 ? false : _ref$skippable,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _lodash.noop : _ref$onError,
    onBack = _ref.onBack;
  var getFieldDecorator = form.getFieldDecorator,
    isFieldValidating = form.isFieldValidating;
  var validationErrors = Object.values(form.getFieldsError()).some(function (v) {
    return v;
  });
  var isValidating = isFieldValidating(fieldName);
  var _useResendTimer = useResendTimer(),
    resetTimer = _useResendTimer.reset,
    secondsLeft = _useResendTimer.secondsLeft;
  var _useStartPhoneVerific = (0, _phoneVerification.useStartPhoneVerification)({
      onSuccess: onSuccess,
      onError: onError
    }),
    onVerify = _useStartPhoneVerific.onVerify,
    verifying = _useStartPhoneVerific.verifying;
  var _useSkipPhoneVerifica = (0, _phoneVerification.useSkipPhoneVerificationCode)({
      onSuccess: onSuccess
    }),
    onSkip = _useSkipPhoneVerifica.onSkip,
    skipping = _useSkipPhoneVerifica.skipping;
  var _useSendPhoneVerifica = (0, _phoneVerification.useSendPhoneVerificationCode)({
      onSuccess: function onSuccess() {
        _toast.toast.success({
          title: 'Verification code sent'
        });
      }
    }),
    onSend = _useSendPhoneVerifica.onSend,
    resendingCode = _useSendPhoneVerifica.sending;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (err) {
        return;
      }
      onVerify({
        verificationCode: values[fieldName],
        phoneNumber: phoneNumber
      });
    });
  };
  var onResend = function onResend() {
    onSend({
      phoneNumber: phoneNumber
    });
    resetTimer();
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading || verifying || resendingCode || skipping
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "tw-subtitle-sm-medium text-black mt-[24px] mb-[24px]"
  }, "Please enter the code we just sent to you via SMS"), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light mb-[12px]"
  }, "We sent a 6-digit code to ", _phoneNumber.PhoneNumberUtils.displayFullPhoneNumber(phoneNumber)), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    className: "--tag-change-phone-number-form"
  }, getFieldDecorator(fieldName, {
    rules: [{
      required: true,
      message: 'Please enter a 6-digit code'
    }, {
      pattern: _patterns.phoneVerificationCodeRegex,
      message: 'Please enter a 6-digit code'
    }]
  })( /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    wrapperStyles: "mb-[12px] w-full",
    form: form,
    contained: true,
    name: fieldName,
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    },
    placeholder: "Enter verification code",
    disabled: isValidating
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-[24px]"
  }, "Didn\u2019t get the code?", ' ', /*#__PURE__*/_react.default.createElement(_Button.TextButton, {
    underline: false,
    onClick: function onClick() {
      onResend();
    },
    disabled: secondsLeft > 0
  }, secondsLeft > 0 ? "Resend in ".concat(secondsLeft) : 'Resend')), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col items-center gap-y-[12px] mb-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    htmlType: "submit",
    size: "small",
    disabled: loading || verifying || resendingCode || validationErrors
  }, "Confirm"), onBack && /*#__PURE__*/_react.default.createElement(_Button.TextButton, {
    onClick: function onClick() {
      onBack();
    },
    size: "small",
    disabled: loading || verifying || resendingCode
  }, "Edit phone number"), skippable && /*#__PURE__*/_react.default.createElement(_Button.TextButton, {
    onClick: function onClick() {
      onSkip({
        phoneNumber: phoneNumber
      });
    },
    size: "small",
    disabled: loading || verifying || resendingCode || skipping
  }, "Skip"))));
};
var _default = _form.default.create({
  name: 'PhoneNumberVerification'
})(PhoneNumberVerification);
exports.default = _default;